// extracted by mini-css-extract-plugin
export default {"media":"media_media__B2MO+","backgroundimageMedia":"media_backgroundimageMedia__fOdl0","border":"media_border__7VpFP"};